import PropTypes from 'prop-types'
import React, { useEffect, useCallback } from 'react'
import { upperFirst } from 'lodash'

import { useMetricsLog, useMetricsLogTimeSpent } from 'helpers/uilogging/hooks'
import { useSelector } from 'react-redux'
import { Actions, FEATURE, Items } from '../../logConstants'
import { KEY_CODES } from 'constants'

const LogWrapper = ({
    WrappedComponent,
    isCurrent,
    partnerID,
    slideName,
    isLastSlide,
    onLastSlideBackClick,
    onGoToRecommendedClansButtonClick,
}) => {
    const {
        total,
        dwhType,
        membersCount,
        listType,
        languages,
        loadedBefore,
    } = useSelector((state) => state.recommendedClans)

    const log = useMetricsLog(FEATURE)
    const [start, stop] = useMetricsLogTimeSpent(FEATURE)

    const handleSlideOpen = useCallback((info = null) => {
        start(Actions.Preview)
        log({
            action: Actions.Open,
            item: Items[upperFirst(slideName)],
            parentScreen: Items.Hangar,
            partnerID,
            info: info,
        })
    }, [log, start])

    const handleSlideClose = useCallback(() => {
        stop({
            action: Actions.Preview,
            item: Items[upperFirst(slideName)],
            timeLimit: 1.0,
            partnerID,
        })
    }, [stop])

    useEffect(() => {
        const handleKeyUp = (e) => {
            e.keyCode === KEY_CODES.ESCAPE && handleSlideClose()
        }
        window.addEventListener('keydown', handleKeyUp)

        return () => {
            window.removeEventListener('keydown', handleKeyUp)
        }
    })

    useEffect(() => {
        if (isCurrent && !isLastSlide) {
            handleSlideOpen()
        }
        if (isCurrent && isLastSlide && loadedBefore) {
            const info = JSON.stringify({
                type: dwhType,
                total: total,
                membersCount: membersCount,
                gameLevel: listType,
                languages: languages,
            })
            handleSlideOpen(info)
        }
        return () => {
            handleSlideClose()
        }
    }, [isCurrent, loadedBefore])

    return (
        <WrappedComponent
            partnerID={partnerID}
            onLastSlideBackClick={onLastSlideBackClick}
            onGoToRecommendedClansButtonClick={onGoToRecommendedClansButtonClick}
        />
    )
}

LogWrapper.propTypes = {
    WrappedComponent: PropTypes.elementType.isRequired,
    isCurrent: PropTypes.bool.isRequired,
    isLastSlide: PropTypes.bool.isRequired,
    partnerID: PropTypes.string.isRequired,
    slideName: PropTypes.string.isRequired,
    onLastSlideBackClick: PropTypes.func.isRequired,
    onGoToRecommendedClansButtonClick: PropTypes.func.isRequired,
}

export default LogWrapper



// WEBPACK FOOTER //
// ./containers/Landing/components/LogWrapper/LogWrapper.jsx